import { Slot } from '@radix-ui/react-slot'
import * as React from 'react'

import type { CheckboxGroupItemValue } from './CheckboxGroup.types'
import { CheckboxGroupAllItem } from './CheckboxGroupAllItem'
import { CheckboxGroupItem } from './CheckboxGroupItem'
import { CheckboxGroupSub } from './CheckboxGroupSub'
import { CheckboxGroupCheckedProvider } from './context/CheckboxGroupChecked.context'
import { CheckboxGroupMountedProvider } from './context/CheckboxGroupMounted.context'

type CheckboxGroupRootProps = Omit<
  React.HTMLAttributes<HTMLDivElement>,
  'defaultChecked'
> & {
  checked?: CheckboxGroupItemValue[]
  onCheckedChange?: (checked: CheckboxGroupItemValue[]) => void
  defaultChecked?: CheckboxGroupItemValue[]
  asChild?: boolean
}

const CheckboxGroupRoot = ({
  checked,
  defaultChecked,
  onCheckedChange,
  asChild = false,
  ...rest
}: CheckboxGroupRootProps) => {
  const Component = asChild ? Slot : 'div'

  return (
    <CheckboxGroupCheckedProvider
      checked={checked}
      defaultChecked={defaultChecked}
      onCheckedChange={onCheckedChange}
    >
      <CheckboxGroupMountedProvider>
        <Component {...rest} />
      </CheckboxGroupMountedProvider>
    </CheckboxGroupCheckedProvider>
  )
}

export const CheckboxGroup = Object.assign(CheckboxGroupRoot, {
  Item: CheckboxGroupItem,
  AllItem: CheckboxGroupAllItem,
  Sub: CheckboxGroupSub
})
